export default __webpack_public_path__ + "static/media/novoBG.e2ea4837.jpg";